/** Dev mode → Bugs: every bug the team reported, with the fix state. */
import { getDevBugs } from '../kiaanApi';
import { BUG_PILL } from './Overview';
import { DevState, useDevData } from './useDevData';

export function Bugs() {
  const { data, loading, error } = useDevData(getDevBugs);
  if (!data) return <DevState loading={loading} error={error} />;
  return (
    <div className="kw-grid" style={{ gridTemplateColumns: '1fr' }}>
      <div className="kw-box">
        <h4>Bugs from the team <span>{data.filter((b) => b.status !== 'closed').length} open</span></h4>
        {data.length === 0 && <div className="kw-small">No bugs reported.</div>}
        {data.map((b) => (
          <div key={b.id} className="kw-row" style={{ alignItems: 'flex-start' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              &quot;{b.note}&quot;{b.reporterName ? ` · ${b.reporterName}` : ''}
              <div className="kw-small"><span className="kw-mono">{b.route}</span> · {new Date(b.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}</div>
            </div>
            <span className={`kw-pill ${BUG_PILL[b.status]?.cls ?? ''}`}>{BUG_PILL[b.status]?.label ?? b.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
